module.exports = __webpack_public_path__ + "img/logo_complete.a757b759.png";